// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1mttQ","filesListContainer":"PosDisputesFiles_filesListContainer__2J13s","filesButton":"PosDisputesFiles_filesButton__3sI9L"};